import { useParams } from "react-router-dom";
import { isTaskUpdateMarketInfo } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { UpdateMarketInfoPage } from "./UpdateMarketInfoPage";

const UpdateMarketInfo = () => {
    const { marketId, taskId } = useParams();

    const { tasks, markets } = useAppSelector((state) => state.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    if (!safeMarketId || !safeTaskId) return null;

    const currentTask = tasks?.[safeMarketId]?.[safeTaskId];
    const currentMarket = markets?.[safeMarketId];

    if (
        !currentTask ||
        !isTaskUpdateMarketInfo(currentTask) ||
        !currentMarket
    ) {
        return <NotFound />;
    }

    return <UpdateMarketInfoPage task={currentTask} market={currentMarket} />;
};

export default UpdateMarketInfo;
